/* eslint-disable no-shadow */
/* eslint-disable react/no-array-index-key */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import getTicketsList from '../../../../api/graphql/queries/getTicketsList';

const Tab = ({ handleLocalizedInput, activeLanguage, handleUpdateTickets, index, label, tickets, removeItemTab }) => {
  const [loading, setLoading] = useState(false);
  const [filteredTickets, setFilteredTickets] = useState([]);
  const [query, setQuery] = useState('');

  const updateSearch = async (val) => {
    if (loading) return;
    if (val) {
      setLoading(true);
      try {
        // This picker has no pager, so it asks for the largest page the server
        // allows rather than silently showing only the first 25 matches.
        const ticketsResult = await getTicketsList(val.toLowerCase(), { limit: 100 });
        const { tickets: rawTickets = [] } = ticketsResult;
        setFilteredTickets(rawTickets || []);
        setLoading(false);
      } catch (e) {
        console.log(e);
        setLoading(false);
      }
    }
  };

  const handleAdd = (ticket) => {
    if (tickets.filter(t => t._id === ticket._id).length === 0) {
      tickets.push({
        _id: ticket._id,
        ticketSlugName: ticket.ticketSlugName,
        ticketName: ticket.ticketName,
      });
      handleUpdateTickets(tickets, index);
    }
  };

  const handleRemove = (ticket) => {
    handleUpdateTickets([...tickets.filter(t => t._id !== ticket._id)], index);
  };

  const handleDragEnd = (result) => {
    const { source, destination } = result;

    if (!destination || !source.droppableId) return;
    if (destination.droppableId === source.droppableId && destination.index === source.index) return;

    const newTicketPositions = [...tickets];
    const elementToMove = newTicketPositions.splice(source.index, 1)[0];
    newTicketPositions.splice(destination.index, 0, elementToMove);

    handleUpdateTickets(newTicketPositions, index);
  };

  return (
    <>
      <div className="w-full rounded-lg border-indigo border mb-4">
        <div className="w-full bg-indigo p-4 rounded-tr-lg rounded-tl-lg flex items-center justify-between">
          <input
            placeholder="Category name"
            className="appearance-none block w-fulltext-gray-700 border border-indigo rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
            name={`label-${index}`}
            onChange={e => handleLocalizedInput(e, index)}
            type="text"
            value={label && label[activeLanguage]}
          />
          <div
            className="cursor-pointer"
            onClick={() => {
              // eslint-disable-next-line no-alert
              if (window.confirm('Remove tab?')) removeItemTab(index);
            }}
          >
            Remove
          </div>
        </div>
        <div className="w-full flex">
          <div className="flex-1 p-4 bg-indigo-lightest rounded-bl-lg relative">
            <div className="h-12 flex items-center">
              <div className="text-lg text-black">
                Selected tickets
              </div>
            </div>
            <DragDropContext onDragEnd={handleDragEnd}>
              <Droppable droppableId="selected">
                {(provided, snapshot) => (
                  <div
                    ref={provided.innerRef}
                    className={`${snapshot.isDraggingOver ? '' : ''} relative`}
                    {...provided.droppableProps}
                    style={{
                      minHeight: `${53 * tickets.length}px`,
                    }}
                  >
                    {tickets.map((ticket, index2) => (
                      <Draggable
                        key={ticket._id}
                        draggableId={ticket._id}
                        index={index2}
                      >
                        {provided => (
                          <div
                            key={ticket._id}
                            ref={provided.innerRef}
                            {...provided.draggableProps}
                            {...provided.dragHandleProps}
                            style={provided.draggableProps.style}
                            className="border border-indigo rounded-lg p-2 text-black mb-2 flex"
                          >
                            <div className="flex-1">{ticket.ticketName}</div>
                            <div className="px-2 cursor-pointer" onClick={() => handleRemove(ticket)}>x</div>
                          </div>
                        )}
                      </Draggable>
                    ))}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </div>
          <div className="flex-1  p-4">
            <div className="flex items-center h-12">
              <div className="text-lg text-black">
                Search tickets
              </div>
            </div>
            <div className="flex-1 flex mb-1">
              <input className="border-indigo border rounded-lg p-2 mr-2" type="text" name="query" value={query} onChange={e => setQuery(e.target.value)} placeholder="Search (min 4 characters)" />
              <button className="bg-indigo text-white rounded-lg p-2" type="button" onClick={() => updateSearch(query)}>
                {loading ? 'Searching...' : 'Search tickets'}
              </button>
            </div>
            <div className="">
              {filteredTickets.map(ticket => (
                <div key={`filtered-ticket-${ticket._id}`} onClick={() => handleAdd(ticket)} className={`hover:border-indigo-darker cursor-pointer border border-indigo rounded-lg p-2 text-black mb-1 ${tickets.filter(t => t._id === ticket._id).length > 0 ? ' opacity-10' : ''}`}>
                  {ticket.ticketName}
                  {' '}
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const initialState = {
  type: 'TicketsTabs',
  tabs: [{
    label: {
      en: '',
      es: '',
      ca: '',
      pt: '',
    },
    tickets: [],
  }],
};

const TicketsTabs = ({ activeLanguage, components, id, handlerSetComponents }) => {
  const component = components.find(obj => obj.id === id);

  const [data, setData] = useState(component?.component || initialState);

  const handleLocalizedInput = (e, index) => {
    const { value } = e.target;
    try {
      data.tabs[index].label[activeLanguage] = value;
      setData({
        ...data,
      });
    } catch {
      console.log('Error updating');
    }
  };

  const handleUpdateTickets = (tickets, index) => {
    try {
      data.tabs[index].tickets = [...tickets];
      setData({ ...data });
    } catch {
      console.log('Error updating');
    }
  };

  const addItemTab = () => {
    const newTabs = [
      ...data?.tabs,
      {
        label: {
        },
        position: 0,
        tickets: [],
      },
    ];

    data.tabs = newTabs;

    setData({
      ...data,
    });
  };

  const removeItemTab = (pos) => {
    const newTabs = [...data.tabs];
    newTabs.splice(pos, 1);

    data.tabs = newTabs;

    setData({
      ...data,
    });
  };

  useEffect(() => {
    const componentIndex = components.findIndex(obj => obj.id === id);
    handlerSetComponents({
      id,
      component: data,
    }, componentIndex);
  }, [data]);

  const handleDragEnd = (result) => {
    const { source, destination } = result;

    // dropped outside the list
    if (!destination) {
      return;
    }
    if (destination.droppableId === source.droppableId && destination.index === source.index) return;

    switch (source.droppableId) {
      // origin same as destination, order items
      case destination.droppableId: {
        const tabs = [...data.tabs];

        // Move, not swap. This used to exchange the source and destination entries, so
        // dragging tab 1 onto tab 4 sent tab 4 back to slot 1 instead of shifting the
        // others up. Invisible with two tabs, wrong with three. Every other draggable
        // list here moves - they use lodash-move, which is imported under the misleading
        // name `swap` but does exactly this splice pair.
        const [moved] = tabs.splice(source.index, 1);
        tabs.splice(destination.index, 0, moved);

        data.tabs = tabs;

        // Without this the reorder never left the component. Assigning to data.tabs
        // mutates the prop in place, so the object reference does not change, so the
        // useEffect above - which is what hands the component back to the parent via
        // handlerSetComponents - never re-fires. The tabs visibly reordered and then
        // reverted on reload. addItemTab and removeItemTab both do this; only the drag
        // handler had been missing it, and nobody noticed because the drag itself was
        // broken until the draggableId fix.
        setData({
          ...data,
        });
        break;
      }

      default: {
        break;
      }
    }
  };

  return (
    <>
      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId="selected">
          {(provided, snapshot) => (
            <div
              ref={provided.innerRef}
              className={`${snapshot.isDraggingOver ? '' : ''} relative`}
              {...provided.droppableProps}
            >
              {/*
                draggableId must be a string. It used to be a number, from a
                uniqueNumberFromString helper that turned the tab label into digits and
                parseInt'd them: react-beautiful-dnd 11 tolerated that, 13 does not, and the
                tabs simply stopped dragging. The helper was unsound anyway - a label of any
                length overflowed past 2^53, so two different labels could collapse onto the
                same id, which v13 rejects as a duplicate.
              */}
              {data?.tabs && data.tabs.map((tab, index) => (
                <Draggable
                  key={`containerTicketsTab-${index}`}
                  draggableId={`ticketsTab-${index}`}
                  index={index}
                >
                  {provided => (
                    <div
                      key={`itemTicketsTab-${index}`}
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      style={provided.draggableProps.style}
                    >
                      <Tab
                        {...tab}
                        activeLanguage={activeLanguage}
                        handleUpdateTickets={handleUpdateTickets}
                        handleLocalizedInput={handleLocalizedInput}
                        removeItemTab={removeItemTab}
                        index={index}
                      />
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
      <button
        type="button"
        onClick={addItemTab}
        className="text-white text-xs font-bold h-10 w-full mt-10 uppercase flex items-center justify-center bg-blue-darker"
      >
        Add tab
        {' '}
        <span className="font-icon icon-add-button text-base font-bold pl-2" />
      </button>
    </>
  );
};

TicketsTabs.propTypes = {
  components: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  activeLanguage: PropTypes.string.isRequired,
  handlerSetComponents: PropTypes.func.isRequired,
  id: PropTypes.string.isRequired,
};

Tab.propTypes = {
  handleLocalizedInput: PropTypes.func.isRequired,
  activeLanguage: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  label: PropTypes.shape().isRequired,
  tickets: PropTypes.arrayOf(PropTypes.shape()).isRequired,
  handleUpdateTickets: PropTypes.func.isRequired,
};

export default TicketsTabs;
